import React from "react";
import classnames from "classnames";

import edit from "../../assets/img/edit.svg";
import remove from "../../assets/img/remove.svg";

import "../../assets/styles/Element.scss";

export interface ElementProps {
  index: number;
  children: React.ReactNode;
  onEdit(index: number): void;
  onRemove(index: number): void;
  editIndex?: number | null;
}

export interface ElementState {}

export const Element = (props: ElementProps) => {
  const { index, children, onEdit, onRemove, editIndex } = props;
  return (
    <div className="element">
      <div className="row">
        <div className="col-auto">
          <div
            className={classnames("number-wrapper", {
              editing: editIndex === index,
            })}
          >
            {index + 1}.
          </div>{" "}
        </div>
        <div className="col-auto text-wrapper">{children}</div>
        <div className="col col-sm-auto">
          <div className="row no-gutters justify-content-end">
            <div className="icon-button" onClick={() => onEdit(index)}>
              {editIndex === index ? (
                <div className="close"></div>
              ) : (
                <img src={edit} alt="edit" />
              )}
            </div>
            <div className="icon-button" onClick={() => onRemove(index)}>
              <img src={remove} alt="remove" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Element;
